import React from 'react';
import PositiveToast from '@/components/toasts/PositiveToast';
import ToastMessage from '@/components/toasts/ToastMessage';

const UserRoleUpdateToast = ({ items, role }) => (
  <PositiveToast className="aridhia-user-role-update-toast" icon="drivers license">
    <ToastMessage
      additionalValues={{ roleName: role.name }}
      items={items}
      multiple="toast.users.role.update"
      single="toast.user.role.update"
    />
  </PositiveToast>
);

export default UserRoleUpdateToast;
